module.exports = __webpack_public_path__ + "img/shuai.21ed3c01.gif";